import { render, staticRenderFns } from "./AlbumView.vue?vue&type=template&id=79a51112&"
import script from "./AlbumView.vue?vue&type=script&lang=js&"
export * from "./AlbumView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports